import AxiosManager from "../_axiosManager";

export async function putInquiry({ inquiryId, answer }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/inquiry/${inquiryId}`,
    { answer },
  );

  return res;
}

export async function putCooperate({ cooperateId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/cooperate/${cooperateId}`,
    body,
  );

  return res;
}
